class Pages{
    /**当前页 */
    current=1;
    /**当前size */
    size=10;
    /**搜索关键字 */
    keywords="";
}
/**虚拟仿真分页缓存 */
export const VirtualPages= new Pages();
/**虚仿课程分页缓存 */
export const CoursePages=new Pages();
/**资源库分页缓存 */
export const ResourcePages=new Pages();